<div class="main_page">
    <div class="main-section pt-3">
        <div class="container">
    
    <div class="row">
        <div class="col-md-12">
            <div
                class="founder-messagege p-sm-2 d-flex align-items-center align-items-center justify-content-between">
                <div class="fouder-img">
    
                    <div class="img">
                        <div class="founder-header-text position-relative d-block d-sm-none ">
                            <h2 class="mb-0">The Brain behind iQuanta</h2>
                        </div>
                        <img class="img-fluid d-none d-sm-block" loading="lazy"
                            src="https://media.iquanta.in/ui_images/jeeth-004.webp" alt="indrajeet">
                    </div>
                </div>
                <div class="founder-content text-end p-sm-4">
    
                    <div class="founder-bottom d-block d-sm-none position-absolute">
                        <h3 class="f-bold mb-1">Indrajeet Singh</h3>
    
                        <div class="d-flex align-items-center">
                            <h6 class="f-light mb-0">Founder & CEO</h6>
                            <div class="d-flex jeeth-social-links gap-3">
                                <div (click)="gotolink('https://www.facebook.com/IndrajeetiQuanta')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23"
                                        viewBox="0 0 36 54" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M23.8711 13.7221C25.1275 12.5577 27.0724 12.6846 27.2152 12.691L35.3533 12.6878L35.5309 0.945478L34.303 0.644062C33.5163 0.450562 31.1081 0 25.8001 0C16.3486 0 9.99672 6.61517 9.99672 16.457V19.0999H0.478516V31.7908H9.99672V54H22.6877V31.7908H32.7199L34.4649 19.0999H22.6877V17.155C22.6877 15.6099 23.0874 14.4518 23.8711 13.7221Z"
                                            fill="url(#paint0_linear_970_12740)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_970_12740" x1="18.0047" y1="0"
                                                x2="18.0047" y2="54" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#724A39" />
                                                <stop offset="1" stop-color="#AB7E6B" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </div>
                                <div (click)="gotolink('https://www.instagram.com/indralion/')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23"
                                        viewBox="0 0 54 54" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M15.8481 0.331368C11.4528 0.529682 7.6432 1.60427 4.56703 4.66744C1.48013 7.74669 0.418882 11.5714 0.220073 15.9209C0.0964883 18.6357 -0.626168 39.1453 1.46938 44.5239C2.88254 48.1526 5.66579 50.9426 9.32763 52.3602C11.0363 53.0249 12.9868 53.4748 15.8481 53.6061C39.7723 54.6888 48.6407 54.0993 52.3805 44.5239C53.0441 42.8195 53.5008 40.8707 53.6271 38.0165C54.7205 14.0311 53.4498 8.83206 49.2802 4.66744C45.973 1.36843 42.0828 -0.877283 15.8481 0.331368ZM16.0683 48.7822C13.4489 48.6643 12.0277 48.2278 11.0793 47.8607C8.69361 46.9334 6.90166 45.1489 5.98015 42.7771C4.38431 38.6902 4.91359 19.2793 5.05598 16.1384C5.19568 13.0619 5.81897 10.2501 7.98974 8.07934C10.6763 5.39938 14.1474 4.08596 37.7815 5.15259C40.8657 5.29194 43.684 5.91395 45.8601 8.07934C48.5467 10.7593 49.8793 14.257 48.7939 37.8003C48.6757 40.4133 48.2378 41.8311 47.8697 42.7771C45.4383 49.008 39.8448 49.8729 16.0683 48.7822ZM38.0421 12.6619C38.0421 14.4361 39.4848 15.8787 41.266 15.8787C43.0473 15.8787 44.4926 14.4361 44.4926 12.6619C44.4926 10.8878 43.0473 9.44647 41.266 9.44647C39.4848 9.44647 38.0421 10.8878 38.0421 12.6619ZM13.1292 26.9674C13.1292 34.5677 19.3057 40.7297 26.9249 40.7297C34.5441 40.7297 40.7207 34.5677 40.7207 26.9674C40.7207 19.3671 34.5441 13.2091 26.9249 13.2091C19.3057 13.2091 13.1292 19.3671 13.1292 26.9674ZM17.9705 26.9674C17.9705 22.0363 21.9789 18.0356 26.9249 18.0356C31.871 18.0356 35.8794 22.0363 35.8794 26.9674C35.8794 31.9012 31.871 35.9032 26.9249 35.9032C21.9789 35.9032 17.9705 31.9012 17.9705 26.9674Z"
                                            fill="url(#paint0_linear_970_12736)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_970_12736" x1="27" y1="0" x2="27"
                                                y2="54" gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#724A39" />
                                                <stop offset="1" stop-color="#AB7E6B" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </div>
                                <div (click)="gotolink('https://www.linkedin.com/in/indralion/')">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23"
                                        viewBox="0 0 35 35" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M35.0005 35.001H28.0005V22.7527C28.0005 19.3927 26.5182 17.5181 23.86 17.5181C20.9672 17.5181 19.2505 19.4714 19.2505 22.7527V35.001H12.2505V12.251H19.2505V14.8093C19.2505 14.8093 21.4467 10.9556 26.3957 10.9556C31.3465 10.9556 35.0005 13.9767 35.0005 20.2277V35.001ZM4.27399 8.61255C1.91324 8.61255 0.000488281 6.68416 0.000488281 4.30591C0.000488281 1.92941 1.91324 0.000976562 4.27399 0.000976562C6.63299 0.000976562 8.54573 1.92941 8.54573 4.30591C8.54748 6.68416 6.63299 8.61255 4.27399 8.61255ZM0.000488281 35.001H8.75049V12.251H0.000488281V35.001Z"
                                            fill="url(#paint0_linear_970_12681)" />
                                        <defs>
                                            <linearGradient id="paint0_linear_970_12681" x1="17.5005"
                                                y1="0.000976562" x2="17.5005" y2="35.001"
                                                gradientUnits="userSpaceOnUse">
                                                <stop stop-color="#724A39" />
                                                <stop offset="1" stop-color="#AB7E6B" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                </div>
                            </div>
                        </div>
    
    
    
                    </div>
    
                    <div class="founder-header-text position-relative d-none d-sm-block ">
                        <h2 class="mb-2">The Brain behind iQuanta</h2>
                    </div>
    
                    <p class="f-light mb-2"><span class="f-bold">Indrajeet Singh</span> popularly known as the
                        ‘Wizard of <span class="f-bold">Quant’</span>, is a small town boy from Bihar who has
                        made it big in the Education Industry.</p>
                    <p class="f-light mb-2">Having started from humble beginnings to now being the <span>CEO and
                            Founder</span> of an online CAT Preparation behemoth and India’s largest CAT online
                        coaching is a feat in itself.</p>
                    <p class="f-light mb-2">Having been an aspirant himself, he understands the plight of
                        students and hence came up with the revolutionary idea which has made iQuanta a one-stop
                        online destination for the preparation of all MBA Examinations.</p>
                    <div class="header-actions mt-3 float-right d-none d-sm-block">
                        <button [routerLink]="'/about-us'" class="btn d-flex align-item-center">More About
                            iQuanta
                            <span class="ml-2 d-flex justify-content-center align-items-center rounded-circle">
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10"
                                    viewBox="0 0 14 14" fill="none">
                                    <path d="M1 6.87948L12.7586 6.87948M6.87931 12.7588L6.87931 1.00017"
                                        stroke="white" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                            </span>
                        </button>
                    </div>
                </div>
                <div class="founder-social-content px-sm-4 py-3">
                    <div class="pr-sm-5">
                        <h5 class="f-light mb-sm-4 mb-2 pb-2">Featured as Top Young Entrepreneur of India in
                            many
                            reputed sites
                        </h5>
                        <div class="d-flex flex-wrap founder-links gap-2 mb-sm-4 pb-sm-3">
                            <div rel="nofollow"
                                (click)="gotolink('https://medium.com/@startupphilosophy/top-10-youngest-entrepreneurs-of-india-in-2019-startupphilosophy-dbe14fe6b0ef/')">
                                <img class="img-fluid"
                                    src="https://media.iquanta.in/ui_images/home-image/medium-ij.png"
                                    loading="lazy" alt="iQuanta">
                            </div>
                          
                            <div rel="nofollow"
                                (click)="gotolink('https://www.livemint.com/brand-post/wizard-of-quant-indrajeet-singh-joins-as-director-narayana-business-school-11609929643088.html')">
                                <img class="img-fluid"
                                    src="https://media.iquanta.in/ui_images/new-home/livemint-ij.png"
                                    loading="lazy" alt="iQuanta">
                            </div>
                            <div rel="nofollow"
                                (click)="gotolink('https://www.brilliantread.com/interview-with-indrajeet-singh-founder-and-ceo-at-iquanta/')">
                                <img class="img-fluid"
                                loading="lazy" src="https://media.iquanta.in/ui_images/new-home/br-ij.png" alt="iQuanta">
                            </div>
                         
                            <div rel="nofollow"
                                (click)="gotolink('https://www.quora.com/Who-are-the-most-successful-youngest-entrepreneurs-in-India/answer/Rubita-Yadav-2?ch=10&oid=227861652&share=bd3f1fe4&srid=u7UtpJ&target_type=answer')">
                                <img class="img-fluid"
                                    src="https://media.iquanta.in/ui_images/new-home/quara-ij.png"
                                    loading="lazy"  alt="iQuanta">
                            </div>
                            <div rel="nofollow"
                                (click)="gotolink('https://www.quora.com/What-are-the-names-of-top-young-entrepreneur-of-India/answer/Shivang-Bhardwaj-14?ch=10&oid=357466183&share=957e607f&srid=u7UtpJ&target_type=answer')">
                                <img class="img-fluid"
                                    src="https://media.iquanta.in/ui_images/new-home/quara-ij.png"
                                    loading="lazy" alt="iQuanta">
                            </div>
                            <div rel="nofollow"
                                (click)="gotolink('https://www.quora.com/Who-are-the-most-successful-youngest-entrepreneurs-in-India/answer/Bishal-56')">
                                <img class="img-fluid"
                                    src="https://media.iquanta.in/ui_images/new-home/quara-ij.png"
                                    loading="lazy" alt="iQuanta">
                            </div>
                            <div rel="nofollow"
                                (click)="gotolink('https://www.aninews.in/news/business/business/iquanta-reshapes-cat-preparation-industry-one-facebook-group-at-a-time20210322140723/')">
                                <img class="img-fluid"
                                loading="lazy" src="https://media.iquanta.in/ui_images/new-home/ani-ij.webp" alt="iQuanta">
                            </div>
    
                        </div>
    
                        <div class="founder-bottom d-none d-sm-block">
                            <h3 class="f-bold mb-1">Indrajeet Singh</h3>
                            <h6 class="f-light">Founder & CEO</h6>
    
                            <div class="d-flex jeeth-social-links gap-3 mt-3">
                                <div (click)="gotolink('https://www.facebook.com/IndrajeetiQuanta')">
                                   <img width="23" height="23" src="https://media.iquanta.in/ui_images/facebook-icon.svg" alt="facebook">
                                </div>
                                <div width="23" height="23" (click)="gotolink('https://www.instagram.com/indralion/')">
                                    <img src="https://media.iquanta.in/ui_images/insta-icon.svg" alt="instagram">
                                </div>
                                <div width="23" height="23" (click)="gotolink('https://www.linkedin.com/in/indralion/')">
                                    <img src="https://media.iquanta.in/ui_images/in-icon.svg" alt="Linkdin">
                                </div>
                            </div>
                        </div>
    
                    </div>
    
    
                </div>
            </div>
        </div>
    </div>
    
    </div>
    </div>
</div>
